export type UploaderProps = {};
export enum UPLOAD_STATES {
  PROGRESS = "PROGRESS",
  DONE = "DONE",
  ABORTED = "ABORTED",
  ERROR = "ERROR",
}
